
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

import Text from '../../../common/client/components/Text';

const ObjectListStatus = ({selection}) => {

    const classNames = mergeStyleSets({
        ObjectListStatus: {
            borderTop: '1px #eeeeee solid',
            paddingTop: 4,
            paddingBottom: 4,
        },
        content: {
            paddingLeft: 12,
            color: getTheme().palette.neutralSecondary,
        }
    });

    const hasSelectedObjects = (selection.selectedCount > 0);

    return (
        <Stack horizontal className={classNames.ObjectListStatus}>
            <Stack horizontal className={classNames.content} tokens={{childrenGap: 48}}>
                <Stack.Item>
                    <Text small bold={!hasSelectedObjects}>Zobrazených objektů: {selection.objectCount}</Text>
                </Stack.Item>
                <Stack.Item>
                    <Text small bold={hasSelectedObjects}>Vybraných objektů: {selection.selectedCount}</Text>
                </Stack.Item>
            </Stack>
        </Stack>
    );
}

export default ObjectListStatus;
